// **********************************************************
// Open Content Modal
// **********************************************************

document.querySelectorAll('.teaser-list__item.teaser-list__item--with-modal').forEach((item) => {
  item.addEventListener('click', (ev) => {
    const parentEle = ev.target.closest('.teaser-list__item.teaser-list__item--with-modal');
    const modalEle = parentEle.querySelector('.content-modal');

    if (modalEle) {
      toggleContentModal(modalEle, true);
      ev.preventDefault();
    }
  });
});
